import { useLocation } from 'react-router-dom';
import qs from 'querystring';

export function useSearchQuery<T = any>() {
  const { search } = useLocation();
  const query = qs.parse(search.replace('?', ''));

  return query as T;
}
